
import servicesSummaryImage1 from "../assets/services-summary/services-summary-image-1.png";
import servicesSummaryImage2 from "../assets/services-summary/services-summary-image-2.png";
import servicesSummaryImage3 from "../assets/services-summary/services-summary-image-3.png";
import servicesSummaryImage4 from "../assets/services-summary/services-summary-image-4.png";
import servicesSummaryImage5 from "../assets/services-summary/services-summary-image-5.png";
import servicesSummaryImage6 from "../assets/services-summary/services-summary-image-6.png";

const features = [
  {
    title: "General Dentistry",
    path: "/services/general",
    image: servicesSummaryImage1,
    content:
      "Comprehensive everyday dental care focused on prevention, comfort, and long-term oral health.",
  },
  {
    title: "Aligners",
    path: "services/cosmetic/aligners",
    image: servicesSummaryImage2,
    content:
      "Clear, comfortable aligner treatment designed to straighten your smile discreetly and effectively.",
  },
  {
    title: "Dentures",
    path: "services/restorative/dentures",
    image: servicesSummaryImage3,
    content:
      "Custom-made dentures that restore function, comfort, and confidence in your smile.",
  },
  {
    title: "Dental Emergency",
    path: "services/general/dental-emergency",
    image: servicesSummaryImage4,
    content:
      "Prompt, reliable care to relieve pain and manage urgent dental concerns when you need it most.",
  },
  {
    title: "Full Mouth Rehabilitation",
    path: "/services/restorative/full-mouth-rehabilitation",
    image: servicesSummaryImage5,
    content:
      "Comprehensive treatment plans to restore function, aesthetics, and overall oral health.",
  },
  {
    title: "Dental Veneers",
    path: "services/cosmetic/dental-veneers",
    image: servicesSummaryImage6,
    content:
      "High-quality veneers crafted to enhance the shape, colour, and balance of your smile.",
  },  
];

export default features;